// node modules
import { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

// assets
import CssRecipe from 'components/Recipe/Recipe.scss';

class Content extends Component {
  static COVER_IMAGE_SIZE = 315;

  static getImageCredit(primaryImage, book) {
    const captions = [];

    if (primaryImage?.credit) {
      captions.push(primaryImage.credit);
    }
    if (book.image_credit) {
      captions.push(`Photo: ${book.image_credit}`);
    }

    return captions;
  }
}

export default withStyles(CssRecipe)(Content);
